import './SpinWheel.scss';
import React, {useCallback, useContext, useEffect, useMemo, useState} from "react";
import TimeOut from "../TimeOut/TimeOut";
import {Context} from "../../App";
import RequestManager from "../../services/RequestManager";
import Utils from "../../utils/Utils";
import Wheel from "./Wheel/Wheel";
import {useTranslation} from "react-i18next";

let newResult;
let newResultSuit;

function SpinWheel({isClassicMode}) {
  const {t} = useTranslation();
  const context = useContext(Context);
  const socket = RequestManager.getInstance().webSocket;

  const WHEEL_ITEMS = ["0", "32", "15", "19", "4", "21", "2", "25", "17", "34", "6", "27", "13", "36", "11", "30", "8", "23", "10", "5", "24", "16", "33", "1", "20", "14", "31", "9", "22", "18", "29", "7", "28", "12", "35", "3", "26"];

  const assetsFolder = isClassicMode ? 'wheel' : 'wheel_deluxe';
  const wheelImage = process.env.PUBLIC_URL + `./assets/${assetsFolder}/spin_content.png?${Date.now()}`;
  const wheelSuitsContent = process.env.PUBLIC_URL + `./assets/${assetsFolder}/suits_content.png?${Date.now()}`;
  const wheelTopSlack = process.env.PUBLIC_URL + `./assets/${assetsFolder}/top_slack.png?${Date.now()}`;

  const [result, setResult] = useState('');
  const [resultSuit, setResultSuit] = useState(null);
  const [wheelTurnedOn, setWheelTurnedOn] = useState(false);
  const [marketIsClosed, setMarketIsClosed] = useState(false);

  useEffect(() => {
    const gameData = context.gamesData.get ? context.gamesData.get[Utils.firstKey(context.gamesData.get)] : null;

    if (!isClassicMode && gameData) {
      newResult = gameData?.number?.Number;
      newResultSuit = gameData?.number?.Suit;
    } else if (gameData) {
      newResult = gameData?.number;
    }

    socket.addEventListener(RequestManager.AUTO_GAME_RESULT, parseGameResult);

    return () => socket.removeEventListener(RequestManager.AUTO_GAME_RESULT, parseGameResult);
  }, [context.gamesData.get])

  const parseGameResult = ({detail}) => {
    let updatedResult = detail?.sport[context.gameID]?.region;
    updatedResult = updatedResult[Utils.firstKey(updatedResult)]?.game;
    updatedResult = updatedResult[Utils.firstKey(updatedResult)]?.number;

    if (updatedResult !== undefined) {
      if (isClassicMode) {
        newResult = updatedResult;
      } else {
        newResult = updatedResult['Number'];
        newResultSuit = updatedResult['Suit'];
      }
    }
  }

  const turnTheWheel = () => {
    if (isClassicMode === false) {
      setResultSuit(newResultSuit);
    }

    setResult(newResult);
    setMarketIsClosed(false);
    setWheelTurnedOn(true);
  }

  const getResultIndex = useMemo(() => {
    return WHEEL_ITEMS.indexOf(result?.toString());
  }, [result])

  const getLastResultIndex = useMemo(() => {
    return WHEEL_ITEMS.indexOf(context.lastResultNumber.get?.toString());
  }, [context.lastResultNumber.get])

  const spinAnimationEnd = useCallback(() => {
    setWheelTurnedOn(false);
  }, [])

  const getWheelResult = () => {
    if (isClassicMode === false || wheelTurnedOn) {
      return null
    }
    return <div className="wheel-result">{result || context.lastResultNumber.get}</div>;
  }

  const wheelSuitsVars = {
    '--selected-item-suit': resultSuit > -1 && resultSuit != null ? resultSuit : context.lastResultSuit.get?.toString(),
  }

  return <div className={`spin-wheel ${isClassicMode ? '' : 'deluxe'}`}>
    {wheelTurnedOn ? null :
      <TimeOut turnTheWheelCallback={turnTheWheel} wheelTurnedOn={wheelTurnedOn} isClassicMode={isClassicMode} setMarketIsClosed={setMarketIsClosed} marketIsClosed={marketIsClosed}/>}
    <div className={`container ${isClassicMode ? " classic" : ""}`}>
      {isClassicMode ? getWheelResult() : null }
      <div className="wheel-border">
        { marketIsClosed && <h6 className='bets-closed-text'>{t('bets closed').toUpperCase()}</h6>}
        <img  src={wheelImage} alt=''/>
      </div>
      <img src={wheelTopSlack} alt='' className="wheel-top-slack "/>
      <img className={`suits-content ${wheelTurnedOn ? "suits-content-spinning" : "starting-position-suit"}`}
           src={wheelSuitsContent} alt='' style={wheelSuitsVars}/>
      <Wheel resultIndex={getResultIndex} wheelTurnedOn={wheelTurnedOn} lastNumberIndex={getLastResultIndex}
             spinAnimationEnd={spinAnimationEnd} assetsFolder={assetsFolder} isClassicMode={isClassicMode}/>
    </div>
  </div>
}

export default SpinWheel;
